// Gift Wrap Modal Functionality
console.log('Gift wrap modal script loaded');

class GiftWrapModal {
  constructor() {
    console.log('GiftWrapModal initializing...');
    this.selectedOption = null;
    this.giftMessage = '';
    this.init();
  }
  
  init() {
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('.gift-wrap-trigger');
      if (trigger) {
        this.open();
      }
      
      const closeBtn = e.target.closest('.gift-wrap-modal__close');
      if (closeBtn) {
        this.close();
      }
      
      if (e.target.classList.contains('gift-wrap-modal')) {
        this.close();
      }
      
      const applyBtn = e.target.closest('.gift-wrap-apply');
      if (applyBtn) {
        this.apply();
      }
      
      const resetBtn = e.target.closest('.gift-wrap-reset');
      if (resetBtn) {
        this.reset();
      }
    });
    
    document.addEventListener('change', (e) => {
      if (e.target.classList.contains('gift-wrap-option__radio')) {
        this.selectedOption = e.target.value;
      }
    });
    
    document.addEventListener('input', (e) => {
      if (e.target.id === 'giftMessage') {
        this.giftMessage = e.target.value;
        const countEl = document.querySelector('.gift-message-count');
        if (countEl) {
          countEl.textContent = `${this.giftMessage.length}/200`;
        }
      }
    });
    
    console.log('Event delegation set up');
  }
  
  open() {
    const modal = document.getElementById('giftWrapModal');
    if (modal) {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }
  }
  
  close() {
    const modal = document.getElementById('giftWrapModal');
    if (modal) {
      modal.hidden = true;
      document.body.style.overflow = '';
    }
  }
  
  async apply() {
    const applyBtn = document.querySelector('.gift-wrap-apply');
    if (applyBtn) {
      applyBtn.textContent = 'APPLYING...';
      applyBtn.disabled = true;
    }
    
    try {
      const attributes = {};
      const tags = [];
      
      if (this.selectedOption) {
        const handle = this.selectedOption;
        
        const response = await fetch(`/products/${handle}.js`);
        const product = await response.json();
        
        if (product && product.variants && product.variants.length > 0) {
          const variantId = product.variants[0].id;
          
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: variantId,
              quantity: 1
            })
          });
        }
        
        if (this.selectedOption === 'gift-wrap') {
          tags.push('Gift Wrap');
        }
      }
      
      if (this.giftMessage) {
        attributes['Gift Message'] = this.giftMessage;
        tags.push('Gift Message');
      }
      
      if (tags.length > 0) {
        attributes['_order_tags'] = tags.join(', ');
      }
      
      if (Object.keys(attributes).length > 0) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes })
        });
      }
      
      this.close();
      window.location.reload();
      
    } catch (error) {
      console.error('Error applying gift wrap:', error);
      alert('Something went wrong. Please try again.');
    } finally {
      if (applyBtn) {
        applyBtn.textContent = 'APPLY';
        applyBtn.disabled = false;
      }
    }
  }
  
  async reset() {
    const resetBtn = document.querySelector('.gift-wrap-reset');
    if (resetBtn) {
      resetBtn.textContent = 'RESETTING...';
      resetBtn.disabled = true;
    }
    
    try {
      this.selectedOption = null;
      this.giftMessage = '';
      
      document.querySelectorAll('.gift-wrap-option__radio').forEach(radio => {
        radio.checked = false;
      });
      
      const textarea = document.getElementById('giftMessage');
      if (textarea) {
        textarea.value = '';
      }
      
      const countEl = document.querySelector('.gift-message-count');
      if (countEl) {
        countEl.textContent = '0/200';
      }
      
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            'Gift Message': '',
            '_order_tags': ''
          }
        })
      });
      
      this.close();
      window.location.reload();
      
    } catch (error) {
      console.error('Error resetting:', error);
    } finally {
      if (resetBtn) {
        resetBtn.textContent = 'RESET';
        resetBtn.disabled = false;
      }
    }
  }
}

new GiftWrapModal();